export enum OperatorString {
  LT = 'less_than',
  LTE = 'less_than_or_equal_to',
  GT = 'greater_than',
  GTE = 'greater_than_or_equal_to',
  EQ = 'equal_to',
  NEQ = 'not_equal_to',
  IN = 'in',
  INCLUDES = 'string_includes',
  STARTS_WITH = 'string_starts_with',
  ENDS_WITH = 'string_ends_with',
}

export enum OperatorLabel {
  LT = 'is less than',
  LTE = 'is less than or equal to',
  GT = 'is greater than',
  GTE = 'is greater than or equal to',
  EQ = 'is equal to',
  INCLUDES = 'contains',
  STARTS_WITH = 'starts with',
  ENDS_WITH = 'ends with',
}

export const OperatorOperations = {
  [OperatorString.LT]: (a: number, b: number) => {
    return a < b;
  },
  [OperatorString.LTE]: (a: number, b: number) => {
    return a <= b;
  },
  [OperatorString.GT]: (a: number, b: number) => {
    return a > b;
  },
  [OperatorString.GTE]: (a: number, b: number) => {
    return a >= b;
  },
};

// Used in business rule GET response
export type Comparator =
  | OperatorString.EQ
  | OperatorString.NEQ
  | OperatorString.LT
  | OperatorString.LTE
  | OperatorString.GT
  | OperatorString.GTE
  | OperatorString.IN
  | OperatorString.IN
  | OperatorString.INCLUDES
  | OperatorString.STARTS_WITH
  | OperatorString.ENDS_WITH;

export const OperatorStringToLabelMap = {
  [OperatorString.LT]: OperatorLabel.LT,
  [OperatorString.LTE]: OperatorLabel.LTE,
  [OperatorString.GT]: OperatorLabel.GT,
  [OperatorString.GTE]: OperatorLabel.GTE,
  [OperatorString.EQ]: OperatorLabel.EQ,
  [OperatorString.INCLUDES]: OperatorLabel.INCLUDES,
  [OperatorString.STARTS_WITH]: OperatorLabel.STARTS_WITH,
  [OperatorString.ENDS_WITH]: OperatorLabel.ENDS_WITH,
};

export const OperatorOption = {
  [OperatorString.LT]: {
    label: OperatorLabel.LT,
    value: OperatorString.LT,
  },
  [OperatorString.LTE]: { label: OperatorLabel.LTE, value: OperatorString.LTE },
  [OperatorString.GT]: { label: OperatorLabel.GT, value: OperatorString.GT },
  [OperatorString.GTE]: { label: OperatorLabel.GTE, value: OperatorString.GTE },
  [OperatorString.EQ]: { label: OperatorLabel.EQ, value: OperatorString.EQ },
  [OperatorString.INCLUDES]: { label: OperatorLabel.INCLUDES, value: OperatorString.INCLUDES },
  [OperatorString.STARTS_WITH]: {
    label: OperatorLabel.STARTS_WITH,
    value: OperatorString.STARTS_WITH,
  },
  [OperatorString.ENDS_WITH]: { label: OperatorLabel.ENDS_WITH, value: OperatorString.ENDS_WITH },
};

export enum LogicalOperatorEnum {
  AND = 'AND',
  OR = 'OR',
}

export type LogicalOperator = LogicalOperatorEnum.AND | LogicalOperatorEnum.OR;
